<div oui-dialog-title>
  <span class="dialog-title headline-6">{{ title }}</span>
</div>

<oui-dialog-content class="dialog-content">
  @if (isChecking()) {
    <div
      class="loading-container"
      role="status"
      aria-live="polite"
      aria-label="Vérification des conditions d’éligibilité">
      <oui-loading></oui-loading>
    </div>
  }

  @if (eligibility(); as result) {
    @if (result.isEligible) {
      <oui-banner
        type="simple"
        declination="info"
        [title]="'Le consultant est éligible à l’initiation du parcours'"
        [showCloseButton]="false"></oui-banner>
      <span class="body-1">Confirmez-vous l’initiation du parcours ?</span>
    } @else {
      <div class="conditions" aria-label="Raisons bloquant l’initiation">
        @for (condition of blockedConditions(); track condition.code) {
          <oui-banner
            type="simple"
            declination="error"
            [title]="condition.message ?? 'Cette condition n’est pas satisfaite.'"
            [showCloseButton]="false"></oui-banner>
        }
        <span>Le consultant n'est pas éligible à l'initiation du parcours.</span>
      </div>
    }
  }

  @if (eligibilityError(); as message) {
    <oui-banner
      type="simple"
      declination="error"
      [title]="message"
      [showCloseButton]="false"
      role="alert"></oui-banner>
    <oui-button type="text" [disabled]="isChecking()" (click)="checkEligibility()">
      Réessayer la vérification
    </oui-button>
  }

  @if (error(); as message) {
    <oui-banner
      type="simple"
      declination="error"
      [title]="message"
      [showCloseButton]="false"
      role="alert"></oui-banner>
  }
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button type="text" [disabled]="isSaving()" oui-dialog-close>Annuler</oui-button>
  <oui-button type="contained" [disabled]="!canConfirm()" (click)="confirm()">
    {{ isSaving() ? 'Initiation en cours…' : 'Initier le parcours' }}
  </oui-button>
</oui-dialog-actions>
